import React from 'react';
import CompetentProfessionalListTableData from './CompetentProfessionalListTableData';
import { useProjectCompetentProfessionalService } from '../../services/useProjectCompetentProfessional.service';
import './newRow.css';
const CompetentProfessionalListRow = _ref => {
  let {
    companyId,
    data,
    setData,
    rowData,
    emptyRowId = null,
    removeEmptyRow,
    tableHeadings,
    showFileColumns,
    selectedProjectId,
    forNewProjectCreation,
    addCompetentProfessionalToNewProject,
    updateNewProjectCompetentProfessionals,
    removeNewProjectCompetentProfessional
  } = _ref;
  const [saveData, createNewData, deleteData, body, setBody] = useProjectCompetentProfessionalService(companyId, rowData, setData, data, removeEmptyRow, emptyRowId, selectedProjectId);

  // console.log('From CompetentProfessionalListRow: ', data)

  return /*#__PURE__*/React.createElement("tr", {
    className: rowData.id ? '' : 'newRow'
  }, /*#__PURE__*/React.createElement(CompetentProfessionalListTableData, {
    body: body,
    setBody: forNewProjectCreation ? updateNewProjectCompetentProfessionals : setBody,
    saveData: forNewProjectCreation ? updateNewProjectCompetentProfessionals : saveData,
    deleteData: forNewProjectCreation ? removeNewProjectCompetentProfessional : deleteData,
    data: data,
    rowData: rowData,
    createNewData: forNewProjectCreation ? addCompetentProfessionalToNewProject : createNewData,
    removeEmptyRow: removeEmptyRow,
    emptyRowId: emptyRowId,
    tableHeadings: tableHeadings,
    showFileColumns: showFileColumns,
    selectedProjectId: selectedProjectId
  }));
};
export default CompetentProfessionalListRow;